import { container, injectWithTransform } from "tsyringe"

class Optional {
  getOptionalValue(token: string): unknown {
    try {
      return container.resolve(token)
    }
    catch (e) {
      return undefined
    }
  }
}

class OptionalTransform {
  public transform(optional: Optional, token: string): unknown {
    return optional.getOptionalValue(token)
  }
}

/**
 * Inject Optional
 * @see https://github.com/microsoft/tsyringe/issues/182
 * @param token
 * @returns any | undefined
 */
export function injectOptional(token: string):any {
  return injectWithTransform(Optional, OptionalTransform, token)
}
